import { useMutation } from "react-query";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import axios from "axios";


const mutatePostControlAnalysisData = async ({ apiData }) => {
    let apiUrl = `${config.ENDPOINTS["datalake"]}/qc/analysis/control_vs_experiment_analysis`;
    const response = await axios.post(apiUrl, apiData,
        {
            headers: setHeaders()
        });
    if (!response?.data) {
        throw new Error('Network response was not ok');
    }
    return response?.data;
};

const useMutateControlAnalysis = () => {

    const mutation = useMutation(mutatePostControlAnalysisData, {
        mutationKey: 'controlAnalysis',
        onSuccess: (apiData) => {

        },
        onError: (error) => {
            console.log(error);
        },
    }
    );
    return mutation;

};

export default useMutateControlAnalysis;